import React from "react";
import InputContainer from "./InputContainer";
import Select from "react-select";
import { Controller, useController, useForm } from "react-hook-form";
const optionsd = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];
const MultiSelect = React.forwardRef((props, ref) => {
  const {
    label,
    name,
    options,
    optionLabelProp,
    optionValueProp,
    placeholder,
    multiline,
    rows,
    error,
    defaultOption,
    size,
    noPadding,
    disabled,
    control,
    defaultValue,
    value,
    readOnly,
    appendTo,
    setValue,
    watch,
  } = props;
  // console.log("select option", options, value);
  const CustomOption = ({ innerRef, innerProps, ...props }) => {
    return (
      <option
        ref={innerRef}
        {...innerProps}
        value={props?.data[optionValueProp]}
      >
        {props?.data[optionLabelProp]}
      </option>
    );
  };

  return (
    <InputContainer
      {...props}
      noPadding={noPadding}
      size={size}
      label={label}
      error={error}
    >
      <Controller
        control={control}
        name={name}
        rules={props.rules}
        render={(fieldProps) => {
          return (
            <Select
              options={options}
              value={appendTo ? [] : fieldProps.value}
              isMulti={true}
              isDisabled={disabled}
              getOptionLabel={(opt) => opt[optionLabelProp]}
              getOptionValue={(opt) => opt[optionValueProp]}
              onChange={(data) => {
                if (appendTo && setValue && watch) {
                   // Since value is [], data will just contain the newly clicked item(s)
                   const addedItems = data || [];
                   
                   // Clear the select box immediately
                   fieldProps.onChange([]);

                   if (addedItems.length > 0) {
                     let currentMenu = "";
                     // fallback to control.getValues if watch isn't working as a function
                     if (typeof watch === "function") {
                       currentMenu = watch(appendTo);
                     } else if (control && control.getValues) {
                       currentMenu = control.getValues(appendTo);
                     }
                     currentMenu = currentMenu || "";
                     
                     // Parse current menu into an array
                     let menuArray = currentMenu.split(",").map(s => s.trim()).filter(s => s !== "");

                     // Add items that were newly selected
                     addedItems.forEach(a => {
                       menuArray.push(a[optionLabelProp]);
                     });
                     
                     const newMenu = menuArray.join(", ");
                     setValue(appendTo, newMenu, { shouldValidate: true, shouldDirty: true });
                   }
                } else {
                   // Standard MultiSelect behavior
                   fieldProps.onChange(data);
                }
              }}
              menuIsOpen={readOnly ? false : undefined}
              isClearable={!readOnly}
              isSearchable={!readOnly}
            />
          );
        }}
        defaultValue={defaultValue}
      />
    </InputContainer>
  );
});
export default MultiSelect;
